import { render } from "./GestionPremios.vue?vue&type=template&id=1eb81f5a&scoped=true"
import script from "./GestionPremios.vue?vue&type=script&lang=js"
export * from "./GestionPremios.vue?vue&type=script&lang=js"

import "./GestionPremios.vue?vue&type=style&index=0&id=1eb81f5a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1eb81f5a"]])

export default __exports__